import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TransferDetailsEffects } from './effects/transfer-details.effects';
import * as fromTransferDetails from './reducers/transfer-details.reducer';
import { TransferDetailsComponent } from './transfer-details.component';
import { ModalEventListComponent } from './modals/modal-event-list/modal-event-list.component';
import { ModalDeleteTransferComponent } from './modals/modal-delete-transfer/modal-delete-transfer.component';
import { RouterModule } from '@angular/router';
import { TRANSFERS_ROUTES } from './transfer-details.routes';
import { SmashDataTableModule } from '@app/shared/modules/smash-data-table/smash-data-table.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';


@NgModule({
  declarations: [
    TransferDetailsComponent, ModalEventListComponent, ModalDeleteTransferComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    SmashDataTableModule,
    RouterModule.forChild(TRANSFERS_ROUTES),
    StoreModule.forFeature(fromTransferDetails.transferDetailsFeatureKey, fromTransferDetails.reducer),
    EffectsModule.forFeature([TransferDetailsEffects]),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TransferDetailsComponent]
})
export class TransferDetailsModule { }
